import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiceCountryStateComponent } from './mice-country-state.component';
import { RouterModule, Routes } from '@angular/router';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { EnquiryPopupComponent } from './EnquiryPopup/enquiry-popup/enquiry-popup.component';
import { FormsModule } from '@angular/forms';

export const routes: Routes = [
  { path: ':state', component: MiceCountryStateComponent },
]


@NgModule({
  declarations: [MiceCountryStateComponent, EnquiryPopupComponent],
  imports: [
    CommonModule,
    NgbNavModule,
    FormsModule,
    RouterModule.forChild(routes),

  ]
})
export class CountryModule { }
